import { UUIDPathRegex } from '@cbgms/base/utils/uuid'

export const ConceptAppPath = '/conceptapp'
export const ConceptAppRequestMatchURL = `/conceptapp/request/:requestUUID(${UUIDPathRegex})`
